"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateDirectCommitEligibility = evaluateDirectCommitEligibility;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const array_submodels_1 = require("../../../../../PackageStore/ComponentArrays/array-submodels");
const supported_sigma_model_types_1 = require("./supported-sigma-model-types");
const array_resolution_adapter_1 = require("./array-resolution-adapter");
const form_completion_rules_1 = require("./form-completion-rules");
function withStructuralArraySignalNames(formSignals, spiceModels, elementSignals) {
    const terminalNameById = new Map(elementSignals.map((signal) => [String(signal.id), signal.name]));
    const structuralNameByComponentId = new Map();
    for (const submodel of spiceModels.filter(sigma_engine_shared_1.DesignModels.SPICE.isSubModelSigmaSubModel)) {
        for (const connection of submodel.modelInfo.signalConnectionMap) {
            const terminalName = terminalNameById.get(String(connection.modelSignalId));
            if (terminalName !== undefined) {
                structuralNameByComponentId.set(String(connection.componentSignalId), (0, array_submodels_1.composeArraySignalName)(submodel.subModelId, terminalName));
            }
        }
    }
    return formSignals.map((signal) => {
        const structuralName = structuralNameByComponentId.get(String(signal.id));
        return structuralName === undefined ? signal : { ...signal, name: structuralName };
    });
}
function parametersSetOnEveryElement(spiceModels) {
    const elements = (spiceModels ?? []).filter(sigma_engine_shared_1.DesignModels.SPICE.isSubModelSigmaSubModel);
    const representative = (0, array_resolution_adapter_1.readArrayElementParametersFromSubModels)(spiceModels);
    return Object.fromEntries(Object.entries(representative).filter(([name]) => elements.every((element) => element.modelInfo.parameterMap?.[name] !== undefined)));
}
function computeCompletionChecks(formOutput, getSigmaModelShape) {
    const arrayForm = (0, array_resolution_adapter_1.readArrayFormFromResolution)({
        sigmaModelId: formOutput.sigmaModelType,
        spiceModels: formOutput.spiceModels,
    });
    if (arrayForm !== null) {
        const inScope = (0, supported_sigma_model_types_1.isFormFlowSupportedSigmaModelType)(formOutput.sigmaModelType, arrayForm.elementModelType);
        const elementShape = getSigmaModelShape(arrayForm.elementModelType);
        const { pinoutComplete: pinCountMatchesSignalCount, requiredParamsSet } = (0, form_completion_rules_1.arrayFormCompletion)({
            elementShape,
            formSignals: withStructuralArraySignalNames(formOutput.signals, formOutput.spiceModels ?? [], elementShape?.signals ?? []),
            pinout: formOutput.pinout,
            parameters: parametersSetOnEveryElement(formOutput.spiceModels),
            elementCount: arrayForm.elementCount,
            submodelPrefix: arrayForm.submodelPrefix,
        });
        return { inScope, pinCountMatchesSignalCount, requiredParamsSet };
    }
    const inScope = (0, supported_sigma_model_types_1.isFormFlowSupportedSigmaModelType)(formOutput.sigmaModelType, '');
    const modelShape = getSigmaModelShape(formOutput.sigmaModelType);
    if (modelShape !== null && (modelShape.repeatableBlocks?.length ?? 0) > 0) {
        const { pinoutComplete: pinCountMatchesSignalCount, requiredParamsSet } = (0, form_completion_rules_1.repeatableBlockFormCompletion)({
            modelShape,
            formSignals: formOutput.signals,
            pinout: formOutput.pinout,
            parameters: formOutput.parameters,
        });
        return { inScope, pinCountMatchesSignalCount, requiredParamsSet };
    }
    const { pinoutComplete: pinCountMatchesSignalCount, requiredParamsSet } = (0, form_completion_rules_1.simpleFormCompletion)({
        modelShape,
        formSignals: formOutput.signals,
        pinout: formOutput.pinout,
        parameters: formOutput.parameters,
    });
    return { inScope, pinCountMatchesSignalCount, requiredParamsSet };
}
function evaluateDirectCommitEligibility(args) {
    const { formOutput, getSigmaModelShape } = args;
    const notBailed = !formOutput.formBailout.bailedOut;
    if (!notBailed) {
        return {
            canCommitDirectly: false,
            reasons: { inScope: false, pinCountMatchesSignalCount: false, requiredParamsSet: false, notBailed },
        };
    }
    const checks = computeCompletionChecks(formOutput, getSigmaModelShape);
    const canCommitDirectly = checks.inScope && checks.pinCountMatchesSignalCount && checks.requiredParamsSet && notBailed;
    return { canCommitDirectly, reasons: { ...checks, notBailed } };
}
//# sourceMappingURL=direct-commit-eligibility.js.map